import {
	ariaAttributes,
	attrValueB,
	attrValueBt,
	attrValueCe,
	attrValueD,
	attrValueDecoding,
	attrValueEkh,
	attrValueEt,
	attrValueFm,
	attrValueIm,
	attrValueInputautocomplete,
	attrValueLoading,
	attrValueLt,
	attrValueM,
	attrValueO,
	attrValuePl,
	attrValueReferrerpolicy,
	attrValueRoles,
	attrValueS,
	attrValueSb,
	attrValueSh,
	attrValueT,
	attrValueTarget,
	attrValueTk,
	attrValueW,
	attrValueXo,
	attrValueY,
} from "../markup/data.js"
import { AttributeConfig, TagConfig } from "../types.js"

const fetchPriority = ["high", "low", "auto"]

const align = ["left", "center", "right", "justify", "char"]

const mediaAttrs = {
	autoPlay: null,
	controls: null,
	controlsList: null,
	crossOrigin: attrValueXo,
	loop: null,
	mediaGroup: null,
	muted: null,
	playsInline: null,
	preload: attrValuePl,
	src: null,
}

const globalReactAttributes: AttributeConfig = {
	...ariaAttributes,

	// React-specific Attributes
	suppressContentEditableWarning: null,
	suppressHydrationWarning: null,
	children: null,
	dangerouslySetInnerHTML: null,
	ref: null,
	key: null,

	// Standard HTML Attributes
	accessKey: null,
	autoFocus: null,
	className: null,
	contentEditable: attrValueCe,
	contextMenu: null,
	dir: attrValueD,
	enterKeyHint: attrValueEkh,
	draggable: attrValueB,
	hidden: null,
	id: null,
	lang: null,
	slot: null,
	spellCheck: attrValueB,
	style: null,
	tabIndex: null,
	title: null,
	translate: attrValueY,

	// Unknown
	radioGroup: null,

	// WAI-ARIA
	role: attrValueRoles,

	// RDFa Attributes
	about: null,
	datatype: null,
	inlist: null,
	prefix: null,
	property: null,
	resource: null,
	rev: null,
	typeof: null,
	vocab: null,

	// Non-standard Attributes
	autoCapitalize: null,
	autoCorrect: null,
	autoSave: null,
	color: null,
	itemProp: null,
	itemScope: null,
	itemType: null,
	itemID: null,
	itemRef: null,
	results: null,
	security: null,
	unselectable: attrValueO,
	inputMode: attrValueIm,
	is: null,

	// Clipboard Events
	onCopy: null,
	onCopyCapture: null,
	onCut: null,
	onCutCapture: null,
	onPaste: null,
	onPasteCapture: null,

	// Composition Events
	onCompositionEnd: null,
	onCompositionEndCapture: null,
	onCompositionStart: null,
	onCompositionStartCapture: null,
	onCompositionUpdate: null,
	onCompositionUpdateCapture: null,

	// Focus Events
	onFocus: null,
	onFocusCapture: null,
	onBlur: null,
	onBlurCapture: null,

	// Form Events
	onChange: null,
	onChangeCapture: null,
	onBeforeInput: null,
	onBeforeInputCapture: null,
	onInput: null,
	onInputCapture: null,
	onReset: null,
	onResetCapture: null,
	onSubmit: null,
	onSubmitCapture: null,
	onInvalid: null,
	onInvalidCapture: null,

	// Image Events
	onLoad: null,
	onLoadCapture: null,
	onError: null,
	onErrorCapture: null,

	// Keyboard Events
	onKeyDown: null,
	onKeyDownCapture: null,
	onKeyPress: null,
	onKeyPressCapture: null,
	onKeyUp: null,
	onKeyUpCapture: null,

	// Media Events
	onAbort: null,
	onAbortCapture: null,
	onCanPlay: null,
	onCanPlayCapture: null,
	onCanPlayThrough: null,
	onCanPlayThroughCapture: null,
	onDurationChange: null,
	onDurationChangeCapture: null,
	onEmptied: null,
	onEmptiedCapture: null,
	onEncrypted: null,
	onEncryptedCapture: null,
	onEnded: null,
	onEndedCapture: null,
	onLoadedData: null,
	onLoadedDataCapture: null,
	onLoadedMetadata: null,
	onLoadedMetadataCapture: null,
	onLoadStart: null,
	onLoadStartCapture: null,
	onPause: null,
	onPauseCapture: null,
	onPlay: null,
	onPlayCapture: null,
	onPlaying: null,
	onPlayingCapture: null,
	onProgress: null,
	onProgressCapture: null,
	onRateChange: null,
	onRateChangeCapture: null,
	onResize: null,
	onResizeCapture: null,
	onSeeked: null,
	onSeekedCapture: null,
	onSeeking: null,
	onSeekingCapture: null,
	onStalled: null,
	onStalledCapture: null,
	onSuspend: null,
	onSuspendCapture: null,
	onTimeUpdate: null,
	onTimeUpdateCapture: null,
	onVolumeChange: null,
	onVolumeChangeCapture: null,
	onWaiting: null,
	onWaitingCapture: null,

	// MouseEvents
	onAuxClick: null,
	onAuxClickCapture: null,
	onClick: null,
	onClickCapture: null,
	onContextMenu: null,
	onContextMenuCapture: null,
	onDoubleClick: null,
	onDoubleClickCapture: null,
	onDrag: null,
	onDragCapture: null,
	onDragEnd: null,
	onDragEndCapture: null,
	onDragEnter: null,
	onDragEnterCapture: null,
	onDragExit: null,
	onDragExitCapture: null,
	onDragLeave: null,
	onDragLeaveCapture: null,
	onDragOver: null,
	onDragOverCapture: null,
	onDragStart: null,
	onDragStartCapture: null,
	onDrop: null,
	onDropCapture: null,
	onMouseDown: null,
	onMouseDownCapture: null,
	onMouseEnter: null,
	onMouseLeave: null,
	onMouseMove: null,
	onMouseMoveCapture: null,
	onMouseOut: null,
	onMouseOutCapture: null,
	onMouseOver: null,
	onMouseOverCapture: null,
	onMouseUp: null,
	onMouseUpCapture: null,

	// Selection Events
	onSelect: null,
	onSelectCapture: null,

	// Touch Events
	onTouchCancel: null,
	onTouchCancelCapture: null,
	onTouchEnd: null,
	onTouchEndCapture: null,
	onTouchMove: null,
	onTouchMoveCapture: null,
	onTouchStart: null,
	onTouchStartCapture: null,

	// Pointer Events
	onPointerDown: null,
	onPointerDownCapture: null,
	onPointerMove: null,
	onPointerMoveCapture: null,
	onPointerUp: null,
	onPointerUpCapture: null,
	onPointerCancel: null,
	onPointerCancelCapture: null,
	onPointerEnter: null,
	onPointerLeave: null,
	onPointerOver: null,
	onPointerOverCapture: null,
	onPointerOut: null,
	onPointerOutCapture: null,
	onGotPointerCapture: null,
	onGotPointerCaptureCapture: null,
	onLostPointerCapture: null,
	onLostPointerCaptureCapture: null,

	// UI Events
	onScroll: null,
	onScrollCapture: null,

	// Wheel Events
	onWheel: null,
	onWheelCapture: null,

	// Animation Events
	onAnimationStart: null,
	onAnimationStartCapture: null,
	onAnimationEnd: null,
	onAnimationEndCapture: null,
	onAnimationIteration: null,
	onAnimationIterationCapture: null,

	// Transition Events
	onTransitionEnd: null,
	onTransitionEndCapture: null,
}

const empty: AttributeConfig = {}

const reactTags: TagConfig = {
	// @ts-expect-error Allow null-prototype
	__proto__: null,
	html: {
		manifest: null,
	},
	head: {
		profile: null,
	},
	title: empty,
	base: {
		href: null,
		target: attrValueTarget,
	},
	link: {
		as: null,
		crossOrigin: attrValueXo,
		fetchPriority: fetchPriority,
		href: null,
		hrefLang: null,
		rel: null,
		media: null,
		imageSrcSet: null,
		imageSizes: null,
		referrerPolicy: attrValueReferrerpolicy,
		sizes: null,
		type: null,
		charSet: null,
	},
	meta: {
		charSet: null,
		httpEquiv: null,
		content: null,
		media: null,
		name: null,
	},
	style: {
		media: null,
		nonce: null,
		scoped: null,
		type: null,
	},
	body: empty,
	article: empty,
	section: empty,
	nav: empty,
	aside: empty,
	h1: empty,
	h2: empty,
	h3: empty,
	h4: empty,
	h5: empty,
	h6: empty,
	header: empty,
	footer: empty,
	address: empty,
	p: empty,
	hr: empty,
	pre: empty,
	blockquote: {
		cite: null,
	},
	ol: {
		reversed: null,
		start: null,
		type: attrValueLt,
	},
	ul: empty,
	li: {
		value: null,
	},
	dl: empty,
	dt: empty,
	dd: {
		nowrap: null,
	},
	figure: empty,
	figcaption: empty,
	main: empty,
	div: empty,
	a: {
		download: null,
		href: null,
		hrefLang: null,
		media: null,
		ping: null,
		referrerpolicy: null,
		rel: null,
		target: attrValueTarget,
		type: null,
	},
	em: empty,
	strong: empty,
	small: empty,
	s: empty,
	cite: empty,
	q: {
		cite: null,
	},
	dfn: empty,
	abbr: empty,
	ruby: empty,
	rt: empty,
	rp: empty,
	time: {
		dateTime: null,
	},
	code: empty,
	var: empty,
	samp: empty,
	kbd: empty,
	sub: empty,
	sup: empty,
	i: empty,
	b: empty,
	u: empty,
	mark: empty,
	bdi: empty,
	bdo: empty,
	span: empty,
	br: empty,
	wbr: empty,
	ins: {
		cite: null,
		dateTime: null,
	},
	del: {
		cite: null,
		dateTime: null,
	},
	picture: empty,
	img: {
		alt: null,
		crossOrigin: attrValueXo,
		decoding: attrValueDecoding,
		fetchPriority: fetchPriority,
		height: null,
		loading: attrValueLoading,
		referrerPolicy: attrValueReferrerpolicy,
		sizes: null,
		src: null,
		srcSet: null,
		useMap: null,
		width: null,
	},
	iframe: {
		allow: null,
		allowFullscreen: null,
		allowTransparency: null,
		frameBorder: null,
		height: null,
		loading: attrValueLoading,
		marginHeight: null,
		marginWidth: null,
		name: null,
		referrerPolicy: attrValueReferrerpolicy,
		sandbox: attrValueSb,
		scrolling: null,
		seamless: null,
		src: null,
		srcDoc: null,
		width: null,
	},
	embed: {
		height: null,
		src: null,
		type: null,
		width: null,
	},
	object: {
		classID: null,
		data: null,
		form: null,
		height: null,
		name: null,
		type: null,
		useMap: null,
		width: null,
		wmode: null,
	},
	param: {
		name: null,
		value: null,
	},
	video: {
		height: null,
		poster: null,
		width: null,
		disablePictureInPicture: null,
		disableRemotePlayback: null,
		...mediaAttrs,
	},
	audio: mediaAttrs,
	source: {
		height: null,
		media: null,
		sizes: null,
		src: null,
		srcSet: null,
		type: null,
		width: null,
	},
	track: {
		default: null,
		kind: attrValueTk,
		label: null,
		src: null,
		srcLang: null,
	},
	map: {
		name: null,
	},
	area: {
		alt: null,
		coords: null,
		download: null,
		href: null,
		hrefLang: null,
		media: null,
		referrerPolicy: attrValueReferrerpolicy,
		rel: null,
		shape: attrValueSh,
		target: attrValueTarget,
	},
	table: {
		align: ["left", "center", "right"],
		bgcolor: null,
		border: null,
		cellPadding: null,
		cellSpacing: null,
		frame: null,
		rules: ["none", "groups", "rows", "columns", "all"],
		summary: null,
		width: null,
	},
	caption: empty,
	colgroup: {
		span: null,
	},
	col: {
		span: null,
		width: null,
		// align: null,
	},
	tbody: empty,
	thead: empty,
	tfoot: empty,
	tr: empty,
	td: {
		abbr: null,
		align: align,
		colSpan: null,
		headers: null,
		rowSpan: null,
		scope: null,
		height: null,
		width: null,
		valign: ["top", "middle", "bottom", "baseline"],
	},
	th: {
		abbr: null,
		align: align,
		colSpan: null,
		headers: null,
		rowSpan: null,
		scope: attrValueS,
	},
	search: empty,
	form: {
		acceptCharset: null,
		action: null,
		autoComplete: attrValueO,
		encType: attrValueEt,
		method: attrValueM,
		name: null,
		noValidate: null,
		target: attrValueTarget,
	},
	label: {
		form: null,
		htmlFor: null,
	},
	input: {
		accept: null,
		alt: null,
		autoComplete: attrValueInputautocomplete,
		capture: null,
		checked: null,
		defaultValue: null,
		defaultChecked: null,
		// Not suppported yet
		// dirName: null,
		disabled: null,
		form: null,
		formAction: null,
		formEncType: attrValueEt,
		formMethod: attrValueFm,
		formNoValidate: null,
		formTarget: attrValueTarget,
		height: null,
		list: null,
		max: null,
		maxLength: null,
		min: null,
		minLength: null,
		multiple: null,
		name: null,
		pattern: null,
		placeholder: null,
		readOnly: null,
		required: null,
		size: null,
		src: null,
		step: null,
		type: attrValueT,
		value: null,
		width: null,

		onChange: null,
	},
	button: {
		autoComplete: null,
		disabled: null,
		form: null,
		formAction: null,
		formEnctype: attrValueEt,
		formMethod: attrValueFm,
		formNoValidate: null,
		formTarget: attrValueTarget,
		name: null,
		type: attrValueBt,
		value: null,
	},
	select: {
		autoComplete: attrValueInputautocomplete,
		defaultValue: null,
		disabled: null,
		form: null,
		multiple: null,
		name: null,
		required: null,
		size: null,
		value: null,
		onChange: null,
	},
	datalist: empty,
	optgroup: {
		disabled: null,
		label: null,
	},
	option: {
		disabled: null,
		label: null,
		selected: null,
		value: null,
	},
	textarea: {
		autoComplete: attrValueInputautocomplete,
		cols: null,
		defaultValue: null,
		// Not supported yet
		// dirName: null,
		disabled: null,
		form: null,
		maxLength: null,
		minLength: null,
		name: null,
		placeholder: null,
		readOnly: null,
		required: null,
		rows: null,
		value: null,
		wrap: attrValueW,

		onChange: null,
	},
	output: {
		htmlFor: null,
		form: null,
		name: null,
	},
	progress: {
		value: null,
		max: null,
	},
	meter: {
		form: null,
		high: null,
		low: null,
		max: null,
		min: null,
		optimum: null,
		value: null,
	},
	fieldset: {
		disabled: null,
		form: null,
		name: null,
	},
	legend: empty,
	details: {
		name: null,
		open: null,
		onToggle: null,
	},
	summary: empty,
	dialog: {
		open: null,
		onCancel: null,
		onClose: null,
	},
	script: {
		async: null,
		charSet: null,
		crossOrigin: attrValueXo,
		defer: null,
		integrity: null,
		noModule: null,
		nonce: null,
		referrerPolicy: attrValueReferrerpolicy,
		src: null,
		type: null,
	},
	noscript: empty,
	template: empty,
	canvas: {
		width: null,
		height: null,
	},
	slot: {
		name: null,
	},
	data: {
		value: null,
	},
	hgroup: empty,
	menu: empty,
}

export { globalReactAttributes, reactTags }
